/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Passkey_Setup_ActionInputs */



/**
* | output |
* | --- |
* | "Set up passkey" |
*
* @param {Auth_Passkey_Setup_ActionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_passkey_setup_action = /** @type {((inputs?: Auth_Passkey_Setup_ActionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Passkey_Setup_ActionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Passkey einrichten")
	return /** @type {LocalizedString} */ ("Set up passkey")
});